function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20,2.5 C20,1.119 18.881,0 17.5,0 C16.119,0 15,1.119 15,2.5 C15,3.203 15.293,3.837 15.76,4.291 L13.614,10.014 C12.896,10.053 12.265,10.393 11.834,10.912 L7.466,9.664 C7.301,8.444 6.266,7.5 5,7.5 C3.619,7.5 2.5,8.619 2.5,10 C2.5,10.736 2.824,11.391 3.33,11.849 L2.271,15.023 C1,15.14 0,16.197 0,17.5 C0,18.881 1.119,20 2.5,20 C3.881,20 5,18.881 5,17.5 C5,16.764 4.676,16.109 4.17,15.651 L5.229,12.477 C5.908,12.414 6.504,12.085 6.916,11.588 L11.284,12.836 C11.449,14.056 12.484,15 13.75,15 C15.131,15 16.25,13.881 16.25,12.5 C16.25,11.797 15.957,11.163 15.49,10.709 L17.636,4.986 C18.952,4.914 20,3.834 20,2.5",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/analytics.349dfd88.svg";
export { SvgComponent as ReactComponent };